import React from "react";
import { CheckCircle2, MessageCircle, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function ThankYouModal({ open, onClose, t, info, onHome }) {
  if (!info) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="thankyou-modal" className="max-w-md rounded-3xl bg-white p-8 text-center">
        <div className="h-16 w-16 rounded-full bg-[#E8F7EE] flex items-center justify-center mx-auto"><CheckCircle2 size={36} className="text-[#1B8A4B]" /></div>
        <DialogTitle className="mt-4 font-display font-extrabold text-2xl text-[#121316] text-center">{t("ty_title")}</DialogTitle>
        <DialogDescription className="mt-2 text-[#5A5D65] text-center">{t("ty_sub")}</DialogDescription>
        <div data-testid="thankyou-details" className="mt-5 rounded-2xl bg-[#FAF8F5] border border-[#E5E0D8] p-4 text-left text-sm space-y-1.5">
          <div><span className="text-[#5A5D65]">{t("ty_paid")}:</span> <b data-testid="thankyou-amount">₹{info.amount}</b></div>
          <div><span className="text-[#5A5D65]">{t("ty_when")}:</span> <b>{info.when}</b></div>
          <div><span className="text-[#5A5D65]">{t("ty_ref")}:</span> <b data-testid="thankyou-ref">{info.id.slice(-6).toUpperCase()}</b></div>
        </div>
        <div className="mt-6 flex flex-col gap-3">
          {info.track && <Link data-testid="thankyou-track" to={info.track} className="inline-flex items-center justify-center gap-2 h-12 rounded-full btn-saffron font-bold"><MapPin size={18} /> {t("ty_track")}</Link>}
          <a data-testid="thankyou-whatsapp" href={info.wa} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 h-12 rounded-full btn-whatsapp font-bold"><MessageCircle size={18} /> {t("ty_wa")}</a>
          <button data-testid="thankyou-home" onClick={onHome} className="h-12 rounded-full btn-dark font-bold">{t("back_home")}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
